export { ThanksPage } from './ThanksPage';



// WEBPACK FOOTER //
// ./ui/views/thanks/index.js